<template>
  <div class="trust-page">
    <div class="section-title">{{ $t('trust') }}</div>
    <div>
      <div v-for="item in list1" :key="item.title">
        <div class="item">
          <div class="img-container">
            <img :src="item.icon" class="img" alt="">
          </div>
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-for="item in list2" :key="item.title">
        <div class="item">
          <div class="img-container">
            <img :src="item.icon" class="img" alt="">
          </div>
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        assets: 'Safe Lending Practices',
        assetsText: 'Fund disbursements will be distributed to consumer financing products. The borrower has gone through the screening process, and has a good and qualified credit score.',
        legal: 'A Credible Company',
        legalText: 'Kredit Pintar is currently registered with the Financial Services Authority (OJK), and is a financial technology company that meets operational standards in Indonesia.',
        money: 'Transparency',
        moneyText: 'Funds provided by the lender will be accommodated in a joint account, and protected by a third party insurance company.',
        technology: 'Cutting-edge Technologies',
        technologyText: 'In minimizing credit risk, preventing default, and monitoring real-time operational conditions, our platform uses a maximum risk control system of big data and model fraud score.',
        trust: 'Why Lending in Kredit Pintar?',
      },
      id: {
        assets: 'Perlindungan Aset',
        assetsText: 'Penyaluran dana akan disalurkan kepada produk pembiayaan pelanggan. Penerima pinjaman telah melalui proses penyaringan yang ketat, dan memiliki riwayat pinjaman bagus dan berkualitas.',
        legal: 'Perlindungan Hukum',
        legalText: 'Saat ini Kredit Pintar telah berizin di Otoritas Jasa Keuangan (OJK), dan merupakan perusahaan teknologi keuangan yang memenuhi standar operasional di Indonesia.',
        money: 'Perlindungan Dana',
        moneyText: 'Dana yang diberikan oleh pemberi pinjaman akan ditampung dalam rekening bersama, dan dilindungi oleh perusahaan asuransi pihak ketiga.',
        technology: 'Dukungan Teknis',
        technologyText: 'Dalam meminimalisir risiko pinjaman, mencegah gagal bayar, dan memonitor kondisi operasional secara real-time, platform kami menggunakan sistem pengendalian risiko big data dan model fraud score secara maksimal.',
        trust: 'Kenapa Pendanaan di Kredit Pintar?',
      },
    },
  },
  data() {
    return {
      list1: [
        {
          title: this.$t('legal'),
          desc: this.$t('legalText'),
          icon: require('@/assets/image/trust/trust-icon1.png'), // eslint-disable-line global-require
        },
        {
          title: this.$t('assets'),
          desc: this.$t('assetsText'),
          icon: require('@/assets/image/trust/trust-icon2.png'), // eslint-disable-line global-require
        },
      ],
      list2: [
        {
          title: this.$t('technology'),
          desc: this.$t('technologyText'),
          icon: require('@/assets/image/trust/trust-icon3.png'), // eslint-disable-line global-require
        },
        {
          title: this.$t('money'),
          desc: this.$t('moneyText'),
          icon: require('@/assets/image/trust/trust-icon4.png'), // eslint-disable-line global-require
        },
      ],
    }
  },
}
</script>

<style lang="stylus" scoped>
.trust-page {
  padding: 30px 16px;
  margin: 0 auto;
  overflow-x: hidden;
}

.item {
  padding: 24px 0;
  margin-bottom: 0;
  display: flex;
  .img-container {
    padding: 0 24px 0 8px;
    .img {
      width: 40px;
      height: 40px;
    }
  }
  .content {
    .title {
      font-size: 18px;
      color: #444;
      margin-bottom: 8px;
    }
    .desc {
      font-size: 14px;
      line-height: 20px;
      color: #888;
    }
  }
}

.trust-row-title {
  font-size: 16px;
  margin-bottom: 24px;
  color: color-primary;
}

.occupy-percent {
  width: 30%;
}
</style>
